import type { AgentCompany } from "../api/e2e";

const regionNames = new Intl.DisplayNames(["en"], { type: "region" });

export function formatCountry(country: string): string {
  const name = regionNames.of(country.toUpperCase());
  return name ? `${name} (${country.toUpperCase()})` : country.toUpperCase();
}

export function filterCompanies(
  companies: readonly AgentCompany[],
  query: string,
): AgentCompany[] {
  const needle = query.trim().toLocaleLowerCase();
  if (needle === "") return [...companies];
  return companies.filter((company) =>
    [
      company.company_name,
      company.ticker,
      company.country,
      formatCountry(company.country),
    ].some((value) => value.toLocaleLowerCase().includes(needle)),
  );
}

export function companyCompletions(
  companies: readonly AgentCompany[],
  query: string,
  limit = 6,
): AgentCompany[] {
  if (query.trim() === "") return [];
  return filterCompanies(companies, query).slice(0, limit);
}
